const columns = () => ([
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 20,
  },
  {
    title: 'Display Name',
    dataIndex: 'displayName',
    key: 'displayName',
    width: 100,
  },
  {
    title: 'Page Key',
    dataIndex: 'pageKey',
    key: 'pageKey',
    width: 100,
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    ellipsis: true,
    width: 150,
  },
  {
    title: 'Added At',
    dataIndex: 'addedAt',
    key: 'addedAt',
    width: 100,
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    width: 200,
  },
]);

export default columns;
